export const PageIds = {
  Help: 'help',
  Settings: 'settings',
  Info: 'info',
  Lang: 'lang',
};
